import type { DocPageContent } from '../docs-content'

const page = {
  order: 17,
  slug: 'local-ai',
  title: '本地 AI 工具',
  description:
    '浏览器内的文本转语音、音乐生成与转录，并带有本地模型缓存。',
  category: '创意工具',
  related: ['scene-browser', 'text-captions-subtitles', 'audio'],
  sections: [
    {
      title: '本地 AI 的工作原理',
      blocks: [
        {
          kind: 'list',
          items: [
            'AI 工具在你的浏览器中使用你自己的硬件运行——没有任何内容被发送到服务器。',
            '首次使用某个模型时，它会下载一次，随后在本地缓存以便复用。',
            '模型运行期间，状态胶囊会显示加载中、活动中、就绪和错误等状态。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '部分工具需要 Chrome 或 Edge 113+（或 Safari 26+）以及 WebGPU 支持。首次下载的模型可能较大。',
        },
      ],
    },
    {
      title: '文本转语音',
      blocks: [
        {
          kind: 'steps',
          items: [
            '打开**AI**标签页并展开**文本转语音**，然后输入或粘贴你的脚本。',
            '选择一个引擎（见下表），然后选择一种声音，并在支持时设置语速、语言与表现力标签。',
            '预览结果，然后**保存并插入**以将链接音频放到播放头处，或**保存到素材库**。',
          ],
        },
        {
          kind: 'table',
          headers: ['引擎', '支持语言', '运行于'],
          rows: [
            ['Kokoro', '英语', 'WebGPU'],
            ['MOSS Nano', '20 种语言', 'CPU'],
            ['Supertonic 3', '31 种语言', '本地 ONNX'],
          ],
        },
      ],
    },
    {
      title: '音乐生成',
      blocks: [
        {
          kind: 'list',
          items: [
            '展开**音乐生成**，用提示词描述曲目，或从“Lo-fi chill”或“Upbeat EDM”等预设开始。',
            '设置时长（秒），然后**生成音乐**；首次运行会下载模型并缓存。',
            '预览片段，然后**保存并插入**到时间轴，或**保存到素材库**。',
          ],
        },
      ],
    },
    {
      title: '转录',
      blocks: [
        {
          kind: 'list',
          items: [
            '转录位于媒体库与转录稿工作流中，与 AI 标签页相互独立。',
            '**Parakeet** 是快速的默认引擎，覆盖多种欧洲语言。',
            'Whisper 模型（Tiny、Base、Small、Large v3 Turbo）也可用，在需要时精剪会回退到 Whisper。',
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: '转录稿可为字幕、转录稿搜索以及填充词移除提供支持——请尽早生成。',
        },
      ],
    },
    {
      title: '管理模型与运行时',
      blocks: [
        {
          kind: 'list',
          items: [
            '打开**存储**设置以管理本地 AI。',
            '使用**本地 AI 模型缓存**查看或清除已下载的模型——在下载损坏时很有用。',
            '使用**卸载本地模型**释放运行时并释放内存。',
            '如果不再需要结果，可以取消长时间运行的任务。',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
